module.exports = __webpack_public_path__ + "img/img0106.11fa1dc8.png";